import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { HiPlus, HiTrash, HiSave, HiX } from "react-icons/hi";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { GetProdSetUpAtomData, SetProdSetUpAtomData } from "../../store/productionSetupAtom";
import LogicContext from "../../Context/LogicContext";
import { productionSetupService } from "../../services/productionSetupservice";
import { isArray } from "lodash";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";



export default function NewProductionSetupPage() {
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const prodSetupAtom = GetProdSetUpAtomData();
    
  


  const [finishedProduct, setFinishedProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [requiredQuantity, setRequiredQuantity] = useState("1");
  const [searchParams] = useSearchParams();
  
  // Use .get() to retrieve the specific key
  const productionId = searchParams.get('productionId');
  const [itemList, setItemList] = useState([]);
    const myPromiseModal = createModal(GeneralModal);
  

  const { register, handleSubmit, formState: { errors }, reset } = useForm();


  useEffect(()=> {
    if(productionId){
         const found = prodSetupAtom?.finished_item_info?.find(
      (item) => item.Item_Id === productionId
    );

    if (found) {
      setFinishedProduct(found);
    loadFinishItem(productionId);


    }
    }
  },[productionId]);




  const handleFinishGoodsChange = (e) => {
    const itemId = e.target.value;
    if (!itemId) {
      return;
    }

    const found = prodSetupAtom?.finished_item_info?.find(
      (item) => item.Item_Id === itemId
    );
    console.log('finished_item ', found);

    if (found) {
      setFinishedProduct(found);
      console.log('found ', found);

    }
    loadFinishItem(itemId);
  };
  



  const loadFinishItem = (itemId)=> {

      // Fetch required items for this finished good
      setItemList([]);
      productionSetupService.productionFinishedItem(itemId).then((res) => {
        if (isArray(res?.data?.required_item_info) && res.data.required_item_info.length) {
          setItemList(
            res.data.required_item_info.map((it) => ({
              ...it,
              setup_quantity_per_unit: it.required_quantity || 1,
            }))
          );
        } else {
          setItemList([]);
          logicContext.showToast("No required items found for this product", "info");
        }
      }).catch(() => {
          setItemList([]);
    setSelectedProduct(null);
        // logicContext.showToast("Failed to load required items", "error");
      });
  }



  const handleAddOrUpdateItem = () => {
    if (!selectedProduct?.Item_Id) {
      return logicContext.showToast("Please select a finished good first", "error");
    }

    if (!requiredQuantity || Number(requiredQuantity) < 1) {
      return logicContext.showToast("Please enter a valid quantity (minimum 1)", "error");
    }

    const alreadyExists = itemList.some((it) => it.item_id === selectedProduct.Item_Id);

    if (alreadyExists) {
      return logicContext.showToast("This item is already in the list", "warning");
    }

    setItemList((prev) => [
      ...prev,
      {
        item_id: selectedProduct.Item_Id,
        item_name: selectedProduct.Item_Name,
        item_sku: selectedProduct.Item_Sku,
        item_category_name: selectedProduct.item_category_name || "—",
        setup_quantity_per_unit: Number(requiredQuantity),
      },
    ]);

    // Reset input
    setRequiredQuantity("1");
  };

  const handleRequiredItemChange = (e) => {
       if (!finishedProduct?.Item_Id) {
      return logicContext.showToast("Please select a finished good first", "error");
    }

    const itemId = e.target.value;
    if (!itemId) {
      setSelectedProduct(null);
      setItemList([]);
      return;
    }

    const found = prodSetupAtom?.required_item_info?.find(
      (item) => item.Item_Id === itemId
    );

    if (found) {
      setSelectedProduct(found);
    }
  };



  const handleQuantityChange = (itemId, newValue) => {
    const num = Number(newValue);
    if (isNaN(num) || num < 1) {
      logicContext.showToast("Quantity must be at least 1", "warning");
      return;
    }

    setItemList((prev) =>
      prev.map((item) =>
        item.item_id === itemId ? { ...item, setup_quantity_per_unit: num } : item
      )
    );
  };

  const handleRemoveItem = (itemId) => {
    setItemList((prev) => prev.filter((item) => item.item_id !== itemId));
  };

  const onSubmit = async () => {
    if (!finishedProduct?.Item_Id) {
      return logicContext.showToast("Please select a finished good", "error");
    }

    if (itemList.length === 0) {
      return logicContext.showToast("Add at least one required item", "error");
    }

        const confirm = await myPromiseModal({
      title: ` Please confirm `,
      body: `${itemList.length} will be added to the production setup`,
      showInput: false,
    });
    if (!confirm?.decision) return;

  const xmlItems = itemList.map(item => `<a><item_id>${item.item_id}</item_id><required_quantity>${item.setup_quantity_per_unit}</required_quantity> </a>`).join('');
    
    const payload = {
      item_id: finishedProduct.Item_Id,
      xml_string: `<root>${xmlItems}</root>`,
      option:1
    };

    try {
      // Replace with your actual save endpoint
      const res = await productionSetupService.submitProductionSetup(payload);
      if (res?.data?.result_status || res?.data?.result_status?.message_id === 1) {
        logicContext.showToast("Production setup saved successfully", "success");
        navigate(-1); // or to list/details
      } else {
        logicContext.showToast(res?.data?.result_status?.message_text || "Save failed", "error");
      }
    } catch (err) {
      console.log('Error ', err);
      logicContext.showToast("Failed to save setup", "error");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-12">
      {/* Sticky Header */}
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate(-1)}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
              >
                <HiX size={20} />
              </button>
              <h1 className="text-xl font-semibold text-gray-900">New Production Setup</h1>
            </div>

            <button
              onClick={handleSubmit(onSubmit)}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium shadow-sm transition-colors"
            >
              <HiSave size={18} />
              Save Setup
            </button>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <div className="bg-white rounded-xl border shadow-sm p-6 lg:p-8">
                {finishedProduct && (
            <div className="mb-8 p-2 bg-blue-200 rounded-lg border border-blue-400">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <label className="block text-xs text-gray-600">Finished Product</label>
                  <p className="font-medium text-gray-900">{finishedProduct.Item_Name}</p>
                </div>
                <div>
                  <label className="block text-xs text-gray-600">SKU</label>
                  <p className="font-medium text-gray-900">{finishedProduct.Item_Sku || "—"}</p>
                </div>
              
              </div>
            </div>
          )}
          {/* Finish Goods Selector */}
          <div className="flex flex-row gap-6 mb-8">
                  {/* Select Finish Good Container */}
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Select Finish Good
                    </label>
                    <select
                      onChange={handleFinishGoodsChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value="">-- Select a finished good --</option>
                      {prodSetupAtom?.finished_item_info?.map((item) => (
                        <option key={item.Item_Id} value={item.Item_Id}>
                          {item.Item_Name} {item.Item_Sku && `(${item.Item_Sku})`}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Required item(s) Container */}
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Required item(s)
                    </label>
                    <select
                      onChange={handleRequiredItemChange}
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value="">-- Select required item --</option>
                      {prodSetupAtom?.required_item_info?.map((item) => (
                        <option key={item.Item_Id} value={item.Item_Id}>
                          {item.Item_Name} {item.Item_Sku && `(${item.Item_Sku})`}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
          {/* Selected Product Info + Quantity Input */}
    
          {selectedProduct && (
            <div className="mb-4 p-2 bg-gray-50 rounded-lg border border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <label className="block text-xs text-gray-600">Product</label>
                  <p className="font-medium text-gray-900">{selectedProduct.Item_Name}</p>
                </div>
                <div>
                  <label className="block text-xs text-gray-600">SKU</label>
                  <p className="font-medium text-gray-900">{selectedProduct.Item_Sku || "—"}</p>
                </div>
                <div>
                  <label className="block text-xs text-gray-600">Required Quantity</label>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      min="1"
                      value={requiredQuantity}
                      onChange={(e) => setRequiredQuantity(e.target.value)}
                      className="w-28 border border-gray-300 rounded-lg px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                    <button
                      onClick={handleAddOrUpdateItem}
                      className="p-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
                    >
                      <HiPlus size={20} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Items Table */}
          <div className="mt-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Required Items ({itemList.length})
            </h2>

            {itemList.length === 0 ? (
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-10 text-center text-gray-500">
                No items added yet. Select a finish good and add required materials.
              </div>
            ) : (
              <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        ID
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Item Name
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        SKU
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Category
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Quantity
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100">
                    {itemList.map((item) => (
                      <tr key={item.item_id} className="hover:bg-indigo-50/30 transition-colors">
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-700 font-medium">
                          {item.item_id}
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                          {item.item_name}
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-600">
                          {item.item_sku || "—"}
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-600">
                          {item.item_category_name || "—"}
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap">
                          <input
                            type="number"
                            min="1"
                            value={item.setup_quantity_per_unit}
                            onChange={(e) => handleQuantityChange(item.item_id, e.target.value)}
                            className="w-24 border border-gray-300 rounded-lg px-3 py-1.5 text-center focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right">
                          <button
                            onClick={() => handleRemoveItem(item.item_id)}
                            className="p-1.5 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <HiTrash size={18} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="mt-10 flex justify-end gap-4">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit(onSubmit)}
              className="px-8 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-medium shadow-sm transition-colors"
            >
              Save Production Setup
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}